import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Typography, Button, Card, CardMedia, CardContent ,Grid} from "@mui/material";
import { useTranslation } from 'react-i18next';
const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
const newsData = [
 
 {

    id: 1,
    title: t("news.new1.title"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/1743003962059.jpeg",
    shortDescription:t("news.new1.shortDescription"),
    date : "02-04-2025",
    fullText: t("news.new1.fullText"),
  },
    {
  
      id: 2,
      title: t("news.new2.title"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/resim1.jpg",
      date : "06-09-2022",
      shortDescription: t("news.new2.shortDescription"),
      fullText: t("news.new2.fullText"),
    },
    {
      id: 3,
      title:  t("news.new3.title"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/resim2.jpg",
      date : "20-12-2022",
      shortDescription:  t("news.new3.shortDescription"),
      fullText: t("news.new3.fullText"),
    },
];

  const news = newsData.find(n => n.id.toString() === id); // ID eşleşmesini kontrol ediyoruz

  if (!news) {
    return <Typography variant="h5" align="center">Haber bulunamadı</Typography>;
  }
  return (
    <Container sx={{ mt: 5, mb: 5 }}>
      {/* Geri Dön Butonu */}
      <Button
        onClick={() => navigate("/haberler")}  // Haberler sayfasına yönlendirme
        variant="contained"
        color="secondary"
        sx={{
          mb: 4, 
          width: '150px', 
          display: 'block',
          margin: 'left', // Butonu ortaladık
          fontSize: '1rem',
          fontWeight: 'bold',
        }}
      >
        {t('newsDetail.button')} 
      
      </Button>
  
      {/* Haber İçeriği Kartı */}
      <Card sx={{ boxShadow: 5, borderRadius: 3, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        
        {/* Haber Başlığı */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            color: '#1976d2',
            padding: '16px 24px',
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontSize: '2rem',
          }}
        >
          {news.title}
        </Typography>

        <Grid container spacing={2} sx={{ padding: 2 }}>
          
          {/* Resim Bölümü */}
          <Grid item xs={12} sm={6}>
            <CardMedia
              component="img"
              image={news.image}
              alt={news.title}
              sx={{
                objectFit: 'cover',
                height: '400px',
                borderRadius: 2,
              }}
            />
          </Grid>

          {/* Metin Bölümü */}
          <Grid item xs={12} sm={6}>
            <CardContent sx={{ padding: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.8,
                  color: '#555',
                  fontSize: '1.1rem',
                  textAlign: 'justify',
                  mb: 2,
                }}
              >
                {news.fullText}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.6,
                  color: 'text.secondary',
                  fontSize: '1rem',
                  fontStyle: 'italic',
                  textAlign: 'left',
                }}
              >
                {/* Haber altına tarihi eklemek için */}
                <span> {t('newsDetail.text')} {news.date}</span>
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default NewsDetail;
